import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';

const apiUrl = process.env.REACT_APP_API_URL;

function AdminViewLessons() {
  const { batchid } = useParams();
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('Component mounted for batchid:', batchid);
    fetchLessons();
    return () => console.log('Component unmounted for batchid:', batchid); // Track unmount
  }, []); 

  const fetchLessons = async () => {
    setLoading(true);
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('You must be logged in to view lessons.');
        setLoading(false);
        return;
      }
      console.log(`Fetching lessons for batchid: ${batchid} (Type: ${typeof batchid})`);
      const response = await axios.get(`${apiUrl}/api/admin/batch-lessons/${batchid}`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      console.log('API Response:', response.data);
      if (response.data.success) {
        setLessons(response.data.lessons || []);
      } else {
        setError(response.data.message || 'Failed to fetch lessons.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching lessons.');
    } finally {
      setLoading(false);
    }
  };

  // Debug: Log lessons state before render
  console.log('Rendering with lessons:', lessons);

  return (
    <div key={batchid}>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <Link to="/admin-view-batches" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    View Batches
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">View Lessons</span>
                </li>
              </ul>
            </div>
            <Link to={`/admin-add-lesson/${batchid}`} className="btn btn-primary">
              Add Lesson
            </Link>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-24">
              <h4 className="mb-16">Lesson List for Batch {batchid}</h4>
              {loading && (
                <div className="alert alert-info">Loading lessons...</div>
              )}
              {error && (
                <div className="alert alert-danger">{error}</div>
              )}
              {!loading && !error && (
                <>
                  {lessons.length === 0 ? (
                    <div className="alert alert-warning">No lessons found.</div>
                  ) : (
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Date</th>
                          <th>Summary</th>
                          <th>YouTube Link</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lessons.map((lesson) => (
                          <tr key={lesson.id}>
                            <td>{lesson.title || 'Untitled'}</td>
                            <td>{lesson.lesson_date ? new Date(lesson.lesson_date).toLocaleString() : 'N/A'}</td>
                            <td>{lesson.summary || 'N/A'}</td>
                            <td>
                              {lesson.youtube_link ? (
                                <a href={lesson.youtube_link} target="_blank" rel="noopener noreferrer" className="text-primary">
                                  View Video
                                </a>
                              ) : (
                                'N/A'
                              )}
                            </td>
                            <td>
                              {/* Add edit/delete if needed */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default AdminViewLessons;